import { Link, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router';
import { getRouterPathToContentIndex } from '../../utilities/Links';
import { contentTypePluralToOneMap } from '../../types/types';
import SubscriberContentIcon from '../Article/SubscriberContentIcon';

interface OverlineSectionProps {
  type: string;
  openContent: boolean;
}

export default function OverlineSection({
  type,
  openContent,
}: Readonly<OverlineSectionProps>) {
  const { t } = useTranslation();

  const contentTypePlural = Object.entries(contentTypePluralToOneMap).find(
    ([, value]) => value === type,
  )?.[0];

  return (
    <Stack
      direction='row'
      useFlexGap
      sx={{
        gap: 1,
      }}
    >
      {!openContent && (
        <SubscriberContentIcon sx={{ height: '1rem', width: '1rem' }} />
      )}
      <Link
        component={RouterLink}
        variant='overline'
        underline='hover'
        color={'text.secondary'}
        to={getRouterPathToContentIndex(undefined, contentTypePlural)}
      >
        {t(`contentType.${type}`)}
      </Link>
    </Stack>
  );
}
